// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2Pf-H","footer":"ModalCreateQualiphyProcedure_footer__2FruH","additionData":"ModalCreateQualiphyProcedure_additionData__1xp1f"};